import { render, staticRenderFns } from "./ElasticChat.vue?vue&type=template&id=81626cfe&scoped=true&"
import script from "./ElasticChat.vue?vue&type=script&setup=true&lang=js&"
export * from "./ElasticChat.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ElasticChat.vue?vue&type=style&index=0&id=81626cfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81626cfe",
  null
  
)

export default component.exports